import { render, staticRenderFns } from "./CreateJobOfferSettingModal.vue?vue&type=template&id=25b72f2e&scoped=true&"
import script from "./CreateJobOfferSettingModal.vue?vue&type=script&lang=js&"
export * from "./CreateJobOfferSettingModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateJobOfferSettingModal.vue?vue&type=style&index=0&id=25b72f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b72f2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25b72f2e')) {
      api.createRecord('25b72f2e', component.options)
    } else {
      api.reload('25b72f2e', component.options)
    }
    module.hot.accept("./CreateJobOfferSettingModal.vue?vue&type=template&id=25b72f2e&scoped=true&", function () {
      api.rerender('25b72f2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/JobOffers/CreateJobOfferSettingModal.vue"
export default component.exports